import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EpdkConfirmationDialogComponent } from './confirmation-dialog.component';
import { EpdkIconLabelModule } from '../icon-label';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatButtonModule,
    MatDialogModule,
    MatIconModule,

    EpdkIconLabelModule,
  ],
  declarations: [EpdkConfirmationDialogComponent]
})
export class EpdkConfirmationDialogModule { }